<template>
  <div header>
    <header>
      <div class="wrapper">
        <h1><router-link :class="site" :to="`/${site}`">KS 인증시스템</router-link></h1>
        <div class="nav">
          <nav>
            <ul>
              <li><router-link :to="`/${site}/new/guide`">KS인증심사 신청</router-link></li>
              <li><a :href="asset('aboutKs')" target="_blank">KS인증안내</a></li>
              <li><router-link :to="`/${site}/search/products`">KS인증검색</router-link></li>
              <li><router-link :to="`/${site}/complaint/step`">민원센터</router-link></li>
            </ul>
          </nav>
          <div class="side" v-if="isFrontLogin">
            <a href="/logout">로그아웃</a>
            <router-link :to="`/${site}/my`">마이페이지</router-link>
            <router-link :to="`/${site}/cs`">고객센터</router-link>
          </div>
          <div class="side" v-else>
            <a @click="openLogin">로그인</a>
            <router-link :to="`/${site}/join`">회원가입</router-link>
            <router-link :to="`/${site}/cs`">고객센터</router-link>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<style lang="less">
 @import "../../../less/vars";
 @import "../../../less/asset";

  [header] {
    header { .abs; .lt; .wf; .h(76);
      &:before { .cnt; .abs; .lt; .wf; height:1px; background:#fff; opacity:0.2; }
      &:after { .cnt; .abs; .lb; .wf; height:1px; background:#fff; opacity:0.2; }
      h1 { .abs; .lt; .wh(300,76);
        a { .block; .ir; .f; .no-repeat; background-position: center;
          &.kcl { .bg('@{common}/logo-kcl.png'); }
          &.ktr { .bg('@{common}/logo-ktr.png'); }
          &.ktc { .bg('@{common}/logo-ktc.png'); }
          &.kilt { .bg('@{common}/logo-kiel.png'); }
          &.fiti { .bg('@{common}/logo-fiti.png'); }
        }
      }
      .nav { .p(20,0,0,310); color:#fff;
        nav {
          ul { .ib-list; }
          li { .fs(18); .lh(34); .gap-h(75); }
        }
        .side { .abs; .rt(0,20); .ib-list;
          a { .fs(14); .lh(34); .gap-h(18);
            &:first-child { .pl(27); .bg('@{common}/ico-login.png'); .no-repeat; .bg-yc; }
          }
        }
      }
    }
  }
</style>

<script>
export default {
  methods: {
    openLogin() {
      this.$store.commit('openLogin');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/common/AppHeader.vue